import { COMPONENT_TYPES, ITEM_TYPE } from '../config/constants';
import { EVENT, KEYS } from '../contexts/MixpanelConstants';
import { getItemProperties, getMixpanelLinearProperties, getMixpanelVodProperties } from '../contexts/MixpanelHelper';
import h from './common';

export type TrackCarouselItemDetailParams = {
    track: (eventName: string, props?: Record<string, unknown>) => void;
    item: any;
    componentType: string;
    componentName: string;
    meta?: any;
    screenName?: string;
    carouselType?: string;
};

/**
 * Mixpanel events for opening VOD detail from a carousel card / Info (aligned with DetailsButton info click).
 */
export function trackCarouselItemDetailClick({
    track,
    item,
    componentType,
    componentName,
    meta,
    screenName,
    carouselType,
}: TrackCarouselItemDetailParams): void {
    const eventProps = {
        [KEYS.CAROUSEL.SCREEN_NAME]: screenName ?? h.getScreen(),
        [KEYS.CAROUSEL.CAROUSEL_NAME]: componentName,
        [KEYS.CAROUSEL.CAROUSEL_TYPE]: carouselType ?? h.getCarouselComponentType(componentType),
    };
    switch (componentType) {
        case COMPONENT_TYPES.FEATURED_SLIDER:
            track(`${h.getScreen()} - ${EVENT.PROMOTIONS.INFO}`, getItemProperties(item));
            break;
        case COMPONENT_TYPES.VOD_CAROUSEL:
            if (componentName === COMPONENT_TYPES.SEARCH_RECOMMENDATIONS) {
                track(EVENT.SEARCH_RESULTS.RECOMMENDATION_ITEM_CLICK, {
                    [KEYS.GENERAL.SEARCH_RECOMMENDATION_TYPE]: meta && meta.title && meta.title.en ? meta.title.en : '',
                    ...getMixpanelVodProperties(item),
                    ...eventProps,
                });
            } else {
                track(EVENT.CAROUSEL.ITEM_CLICK, {
                    [KEYS.GENERAL.CAROUSLE_NAME]: componentName,
                    ...getMixpanelVodProperties(item),
                    ...eventProps,
                });
            }
            break;
        case COMPONENT_TYPES.VOD_FEATURED_CAROUSEL:
            track(EVENT.CAROUSEL.ITEM_CLICK, {
                [KEYS.GENERAL.CAROUSLE_NAME]: componentName,
                ...getMixpanelVodProperties(item),
                ...eventProps,
            });
            break;
        case COMPONENT_TYPES.USER_WATCHLIST:
            track(EVENT.WATCHLIST.ITEM_CLICK, {
                [KEYS.GENERAL.ITEM_TYPE]: item.category,
                ...getItemProperties(item),
                ...eventProps,
            });
            break;
        case COMPONENT_TYPES.SEARCH_RESULTS:
            track(EVENT.SEARCH_RESULTS.ITEM_CLICK, {
                ...(item.programType && { [KEYS.GENERAL.ITEM_TYPE]: ITEM_TYPE[item.programType.toUpperCase()] }),
                ...getItemProperties(item),
            });
            break;
        case COMPONENT_TYPES.FULLVOD_CATALOG_LIST:
            track(EVENT.VOD_LISTING.ITEM_CLICK, { ...getMixpanelVodProperties(item), ...eventProps });
            break;
        case COMPONENT_TYPES.CONTINIE_WATCHING:
            track(EVENT.CONTINUE_WATCHING.ITEM_CLICK, {
                [KEYS.GENERAL.PROGRAM_TYPE]: item.programType,
                ...(item.programType === 'VOD' ? getMixpanelVodProperties(item) : getMixpanelLinearProperties(item)),
                ...eventProps,
            });
            break;
        case COMPONENT_TYPES.WATCHLIST_CAROUSEL:
            track(EVENT.WATCHLIST_CAROUSEL.ITEM_CLICK, {
                [KEYS.GENERAL.CAROUSLE_NAME]: componentName,
                ...getMixpanelVodProperties(item),
                ...eventProps,
            });
            break;
        case COMPONENT_TYPES.IMAGES_CAROUSEL:
            track(EVENT.IMAGES_CAROUSEL.IMAGE_CLICK, {
                [KEYS.GENERAL.WATCHLIST_TYPE]: item.category,
                ...getItemProperties(item),
                ...eventProps,
            });
            break;
        default:
            break;
    }
}
